import { useEffect } from 'react';
import { useJWTAuth } from './JWTAuthContext';
import { useEntitlements } from '../EntitlementsContext';

/**
 * Custom hook to sync JWT authentication with EntitlementsContext
 * This hook should be used in components that need both JWT auth and entitlements
 */
export const useJWTSync = () => {
  const { user: jwtUser, isAuthenticated } = useJWTAuth();
  const { setJWTUser, userId: entitlementsUserId } = useEntitlements();

  useEffect(() => {
    // If JWT user is authenticated but entitlements doesn't have user data, sync it
    if (isAuthenticated() && jwtUser && !entitlementsUserId) {
      console.log('🔄 [JWT Sync] Syncing JWT user with entitlements:', jwtUser.id);
      setJWTUser(jwtUser.id);
    }
  }, [jwtUser, isAuthenticated, setJWTUser, entitlementsUserId]);

  return {
    jwtUser,
    isAuthenticated,
    entitlementsUserId
  };
};
